var sectionHeader = document.querySelector('.section-header')
  document.documentElement.style.setProperty('--header-height', `${sectionHeader.offsetHeight}px`);
if(document.querySelectorAll('.shopify-section.image_banner_wrapper:first-child .header_section_transparent')){
    document.body.classList.add('transparent__header');
    sectionHeader.classList.add('header_transparent')
  }else{
    document.body.classList.remove('transparent__header');
    sectionHeader.classList.remove('header_transparent')
  }

document.querySelectorAll('.drawer_logo .icon-close, .body_overflow').forEach(function(element) {
  element.addEventListener('click', function() {
    document.body.classList.remove('overflow-hidden-tablet');
    document.getElementById('Details-menu-drawer-container').removeAttribute('open');
  });
});

// product Page tab details
 
document.addEventListener('DOMContentLoaded', function () {
  let TabTitle = document.querySelectorAll('.product_details_grid_item_heading_icon');
  let TabContent = document.querySelectorAll('.product_details');

  TabTitle.forEach(function (tab_title) {
    tab_title.addEventListener('click', function () {
      let title = tab_title.getAttribute('tab-title');
      let isActive = tab_title.classList.contains('tab_title_active');
      
      // Remove active class from all tab titles first
      TabTitle.forEach(function (title) {
        title.classList.remove('tab_title_active');
      });
      
      // Hide all tab contents first
      TabContent.forEach(function (tab_content) {
        tab_content.classList.remove('details');
      });
      
      // If this tab was not active, activate it
      if (!isActive) {
        tab_title.classList.add('tab_title_active');
        TabContent.forEach(function (tab_content) {
          let content = tab_content.getAttribute('tab-content');
          if (title === content) {
            tab_content.classList.add('details');
          }
        });
      }
    });
  });

  if(document.querySelectorAll('.testimonial_section').length > 0){
     $('.testimonial_section').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="17" viewBox="0 0 10 17" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.04965 0.653479C8.69917 0.303007 8.13095 0.303007 7.78048 0.653479L0.372229 8.06173C0.0217567 8.4122 0.0217567 8.98043 0.372229 9.3309L7.78048 16.7391C8.13095 17.0896 8.69917 17.0896 9.04965 16.7391C9.40012 16.3887 9.40012 15.8204 9.04965 15.47L2.27598 8.69631L9.04965 1.92265C9.40012 1.57218 9.40012 1.00395 9.04965 0.653479Z" fill="white"/></svg></button>',
      nextArrow: '<button class="slick-next" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="17" viewBox="0 0 10 17" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.856604 0.653479C1.20708 0.303007 1.7753 0.303007 2.12577 0.653479L9.53402 8.06173C9.88449 8.4122 9.88449 8.98043 9.53402 9.3309L2.12577 16.7391C1.7753 17.0896 1.20708 17.0896 0.856604 16.7391C0.506132 16.3887 0.506132 15.8204 0.856604 15.47L7.63027 8.69631L0.856604 1.92265C0.506132 1.57218 0.506132 1.00395 0.856604 0.653479Z" fill="white"/></svg></button>',
     });
  }
  
  if(document.querySelectorAll('.announcment_bar_grid').length > 0){
    $('.announcment_bar_grid').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000, // 2 seconds
        arrows : false,
        fade : true
    });
  }

  // $(document).find("strong:contains('Chat with us')").on("click", function () {
  //   $(document).find('#ShopifyChat').trigger('click');
  // });

  
});



var addonProduct = document.querySelectorAll('.addonproduct_wrap').length; 
if(addonProduct > 0){
  let checkBoxdiv = document.querySelectorAll('.card_checked input[type="checkbox"]');
  
  checkBoxdiv.forEach(function (inputcheckbox) {
    inputcheckbox.addEventListener('change', function () {
      let anyChecked = Array.from(checkBoxdiv).some(checkbox => checkbox.checked);
      if (anyChecked) {
        document.querySelector('.addonproduct').removeAttribute('disabled');
      } else {
        document.querySelector('.addonproduct').setAttribute('disabled', 'true');
      }
    });
  });

  var buttonAdd = document.querySelector('.addonproduct');
  buttonAdd.addEventListener('click',function(){
    let checkBoxdiv = document.querySelectorAll('.card_checked input[type="checkbox"]');
    var items = [];
    checkBoxdiv.forEach(function (inputcheckbox) {
      if (inputcheckbox.checked) {
        var variantId = inputcheckbox.value ;
        console.log(variantId);

         const item = {
          id : variantId,
          quantity: 1
        }
        items.push(item);
         console.log(items);
      }
    });

    fetch(window.Shopify.routes.root+'cart/add.js',{
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({items}),
    })
    .then(response => {
      return response.json();
      
    })
    .then((data) => {

       fetch(`${window.Shopify.routes.root}`).then(response => response.text()).then(data => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(data, 'text/html');
            const headerCartIconContent = doc.querySelector('#cart-icon-bubble').innerHTML;
            document.querySelector('#cart-icon-bubble').innerHTML = headerCartIconContent;
            const html = new DOMParser().parseFromString(data, 'text/html');
            var drawer_data = html.querySelector('cart-drawer').innerHTML;
            document.querySelector('cart-drawer').innerHTML = drawer_data;
              if (html.querySelectorAll('.cart-item').length === 0) {
                document.querySelector('cart-drawer.drawer').classList.add('is-empty');
              } else {
                document.querySelector('cart-drawer.drawer').classList.remove('is-empty');
              }
            document.querySelector("#cart-icon-bubble").innerHTML = document.querySelector("#cart-icon-bubble").innerHTML;
            var cartIcon = document.querySelector('#cart-icon-bubble');
            cartIcon.dispatchEvent(new Event('click'));  
              
          });
    })
    .catch((error) => {
      console.error('Error adding items:', error);
    });
  });

 
 
}
$('.text_item_greeting textarea').on('keyup', function() {
  var TextVal = $(this).val().length;
  var valSpan = $(this).attr('maxlength');
  var counttext = valSpan - TextVal;
  if(TextVal < 1){
     $('.text_item_greeting').find('#word_remain_id').text('0');
  }else{
    $('.text_item_greeting').find('#word_remain_id').text(TextVal);
    $('.product-form__submit').removeAttr('disabled');
  }
  
});
$('.text_item textarea').on('keyup', function() {
  var TextVal = $(this).val().length;
  var valSpan = $(this).attr('maxlength');
  var counttext = valSpan - TextVal;
  if(TextVal < 1){
     $('.text_item').find('#word_remain').text('0');
  }else{
    $('.text_item').find('#word_remain').text(TextVal);
  }
});